// al final de tot hi ha un export
function llista_rutes() {
var rutes = [
"5VP-galisteo-la_calzada_de_bejar_min.gpx",
"volta_per_collserola_9_min.gpx",
"terrassa-ullastrell-martorell-cornella_min.gpx",
"TP_06_noves_de_segre-llavorsi_min.gpx",
"fageda_irati_min.gpx",
"pujada_a_la_mola_min.gpx",
"St_Feliu_Codines-Poses-Matafaluga-Gallifa_min.gpx",
"volta_per_collserola-3_cims_min.gpx",
"sadernes-sant_aniol_min.gpx",
"st_feliu_de_codines-les_rovires_de_baix_min.gpx",
"la_garriga-vallcarquera-pla_de_la_calma-el_brull-aiguafreda_min.gpx",
"centelles-el_soler_del_coll-sant_feliu_min.gpx",
"port_de_la_selva-roses-dolmens-perafita_min.gpx",
"la_pobla_de_lillet-gombren-castellar_de_nhug_min.gpx",
"volta_broca_sector_sud_min.gpx",
"cercs-peguera_min.gpx",
"MV2-villahermosa_del_rio-cabra_de_mora_min.gpx",
"plana_de_vic_min.gpx",
"MV8-barracas-sagunt_min.gpx~",
"selenika-2022_min.gpx",
"TP_11_fiscal-aurin_min.gpx",
"st_feliu-castelltercol-granera-monistrol-calders-st_fruitos-manresa_min.gpx",
"st_vicenc_calders-el_catllar-bonastre_min.gpx",
"port_de_la_selva-perafita-joncols-cadaques_min.gpx",
"selenika_2023-manresa_min.gpx",
"TP_16_etxalar-hondarribia_min.gpx",
"marxa_castells_min.gpx",
"cornella-begues-ratpenat-castelldefels_min.gpx",
"vilafranca-sta_coloma_queralt-igualada_min.gpx",
"castelltercol-sant-julia-duixols-i-sant-quirze-safaja_min.gpx",
"llucanes_ferestec_2019_min.gpx",
"volta-boumort_min.gpx",
"les_rovires_de_baix_5_min.gpx",
"TNR-7_min.gpx",
"castelldefels-sitges_min.gpx",
"montjuic_min.gpx",
"volta_sant_feliu_3_min.gpx",
"volta_per_collserola_6-can_pascual-floresta-planes_min.gpx",
"cornella-gelida-sant_esteve_sesrovires-martorell-cornella_min.gpx",
"vallcebre-coll_de_pradell-cingles_de_costafreda_min.gpx",
"santa_coloma_gr-les_maleses_min.gpx",
"baga-coll_de_merolla-campdevanol_v2_min.gpx",
"61-tuca_min.gpx",
"sant_feliu-caldes-sentmenat-castellar-can_cadafalch-gallifa_min.gpx",
"macanet_massanes-vic_min.gpx",
"st_vicenc_calders-tarragona-salomo_min.gpx",
"sant_sadurni_danoia-barcelona_min.gpx",
"monnell-vimboca-moixa-afrau_dels_cortals_min.gpx",
"igualada-bellmunt-cervera-pujalt-sant_marti_sesg-igualada_min.gpx",
"la_nou-la_baells-berga-cercs_min.gpx",
"maria_16_anys_min.gpx",
"sant_feliu-sant_miquel_del_fai-sant_quirze_safaja_v2_min.gpx",
"embassament_irabia_min.gpx",
"port_de_la_selva-perafita-cadaques-roses_min.gpx",
"les_rovires_de_baix-tordelespa_min.gpx",
"34-lairissa_min.gpx",
"portbou-colera-llanca-port_de_la_selva_min.gpx",
"VCC3-solsona-pinos-manresa_min.gpx",
"greixer-coll_d_escriu_min.gpx",
"cercs-berga-rasos_peguera-peguera-figols-cercs_min.gpx",
"TNR-8_min.gpx",
"4VP-caceres-galisteo_min.gpx",
"les_rovires_de_baix_3_min.gpx",
"vilafranca-sta_coloma_queralt-igualada-v2_min.gpx",
"st_feliu_codines_gallifa_farell_caldes_min.gpx",
"serra_galliners_part_1_min.gpx",
"coll_destenalles-mura_min.gpx",
"macanet-montsoriu-vic_min.gpx",
"vanoise-cami_de_sarrazin_min.gpx",
"la_garriga-vallforners-pla_calma-la_mora-aiguafreda_min.gpx",
"els_castellets-les_agudes-turo_de_lhome_min.gpx",
"baixador_vallvidrera-sitges_min.gpx",
"Baixador_Vallvidrera-Turons_Can_Pasqual-St_Feliu-Passeig_Aigües_min.gpx",
"aiguafreda-manresa_min.gpx",
"volta_per_collserola_5_floresta_st_just_min.gpx",
"seva-matagalls-viladrau_min.gpx",
"volta_per_baga_2_min.gpx",
"pedraforca_min.gpx",
"MV6-zafrilla-torrebaja_min.gpx",
"TNR-6_min.gpx",
"sabadell-sant_feliu-sabadell_min.gpx",
"collformic-canoves-caldes-mollet_min.gpx",
"paller_de_baix-paller_de_dalt_min.gpx",
"les_rovires_de_baix_4_min.gpx",
"beget-comanegra_min.gpx",
"port_selva-st_baldiri-cala_taballera-cadaques-GR92_min.gpx",
"pineta-llanos_del_larri-cascada_del_cinca_min.gpx",
"st_feliu-caldes-castellar-montmajor_min.gpx",
"banyuls-rumpissar-portbou_min.gpx",
"tavernoles-savassona_min.gpx",
"61-Tuca_min.gpx",
"viladrau-matagalls-agudes-turo_home-santa_fe_min.gpx",
"alp-masella-molina-creueta-baga_min.gpx",
"volta_per_collserola_7-bcn-st_cugat_min.gpx",
"7VP-salamanca-zamora-granja_de_moreruela_min.gpx",
"TP_14_izaba-roncesvalles_min.gpx",
"bcn_stfeliu_1_min.gpx",
"les_rovires_de_baix_2_min.gpx",
"st_feliu-la_garriga_v2_min.gpx",
"sant_celoni-turo_de_lhome_min.gpx",
"51-varrados_min.gpx",
"ager-coll_ares-alsamora-mont-rebei-la_pertusa-corça_min.gpx",
"volta_per_sant_feliu_6_min.gpx",
"centelles-tona-vic-centelles-plana_de_vic_min.gpx",
"santa_eugenia-ridolaina-nas-olia_min.gpx",
"riells-turo_de_les_onze_hores_min.gpx",
"carretera_del_jou_min.gpx",
"cornella-begues-ratpenat-castelldefels-cornella_min.gpx",
"centelles-figaro-tagamanent-aiguafreda_min.gpx",
"serra_ensija-gallina_pelada_min.gpx",
"puigmal-des-del-collet-de-les-barraques_min.gpx",
"2VP-castilblanco_de_los_arroyos-villafranca_de_los_barros_min.gpx",
"baixador_vallvidrera-papiol-la_floresta_min.gpx",
"21-portilhon-coth_de_baretja_min.gpx",
"MV3-cabra_de_mora-bezas_min.gpx",
"mollet-santa_coloma_min.gpx",
"MV7-torrebaja-javalambre-puebla_de_valverde-barracas_min.gpx",
"portilhon-banyeres_de_luchon-tour_de_franca_min.gpx",
"Terrassa-Sant_Feliu_de_Codines_min.gpx",
"granollers-sta_coloma_gr_min.gpx",
"TGEGA-4-innsbruck-mittenwald-garmisch-oberammergau_min.gpx",
"coll_pal-comafloriu-xalet_coll_de_pal_min.gpx",
"puig_de_bestraca_min.gpx",
"baga-la_pobla_de_lillet_min.gpx",
"port_selva-st_pere_de_rodes-llanca-puig_tifell-garbet_min.gpx",
"TP_01_llança-albanya_min.gpx",
"TGEGA-2-ammersee-munich-tegernsee_min.gpx",
"les_rovires-borreda-a_peu_min.gpx",
"baga-refugi_rebost-l_hospitalet_min.gpx",
"berga-cal_rosal-montsent_(el_banc)_min.gpx",
"TP_07_llavorsí-espui_min.gpx",
"revilla-refugio_foratarruego-miradores_de_revilla_min.gpx",
"sta_coloma-st_andreu_llavaneres_min.gpx",
"volta_per_collserola_14_min.gpx",
"cornella-sant_sadurni_d_anoia_min.gpx",
"igualada-calaf-manresa-igualada_min.gpx",
"baga-gresolet-riu_saldes_min.gpx",
"barcelona-vall_del_tenes-sant_feliu_min.gpx",
"les_rovires_de_baix_7_min.gpx",
"ulriken-floyen-bergen_min.gpx",
"cornella-delta_del_llobregat_min.gpx",
"sant_vicenc_de_calders-martorell_min.gpx",
"TP_15_roncesvalles-etxalar_min.gpx",
"sant_feliu-sant_miquel_del_fai-cami_a_llobateres_min.gpx",
"TP_03_camprodon-planoles_min.gpx",
"TGEGA-5-oberammergau-wangen_min.gpx",
"artesa_de_segre-montmagastre_min.gpx",
"baga-pujada_antena_min.gpx",
"montclar-montmajor-cardona_min.gpx",
"vic-volta_riuprimer-muntanyola-vic_min.gpx",
"30-sapartega_min.gpx",
"NO-via_del_nicolau_min.gpx",
"ripoll-olot_min.gpx",
"volta_per_collserola_15_min.gpx",
"sant_celoni-el_sui_min.gpx",
"granollers-canoves-roca_centella-la_garriga-canovelles_min.gpx",
"Baga-Pla_Castell-Collada_Grossa-Refugi_Rebost-Millares_min.gpx",
"volta_per_collserola_5-single_track_min.gpx",
"integral_carretera_aigues_1_min.gpx",
"terrassa-obac-st_vicenc_de_castellet_min.gpx",
"manresa-la_sequia-cornet-rovires_min.gpx",
"via_nicolau_min.gpx",
"rasos_peguera-cogullo_estela-roca_auro-torre_enginyers_min.gpx",
"Monegros-sud_min.gpx",
"Aiguafreda-Collformic-Pla_de_la_Calma-Tagamanent_min.gpx",
"port_de_la_selva-sant_pere_de_rodes-puig_desquers-colera_min.gpx",
"campdevanol-masies_de_gombren-la_pobla-baga_min.gpx",
"vallencana-puig_castellar_min.gpx",
"transpirenaica-en-btt-etapa-5-baga-noves-de-segre_min.gpx",
"baga-coll_de_pal_min.gpx",
"sant_feliu_de_c-sabadell_v2_min.gpx",
"girona-els_angels_min.gpx",
"montcau_min.gpx",
"sant_feliu_de_c-sant_vicenc_de_castellet_min.gpx",
"baga-coll_bena-turbians-roca_de_cans-siti_min.gpx",
"olot-girona_min.gpx",
"els_tres_refugis_min.gpx",
"la_senia-casetes_velles-fredes-la_senia_min.gpx",
"TODO-urus-penyes_altes-refugi_del_cortal_de_vidal_min.gpx",
"vic-viladrau-vic_min.gpx",
"maresme_challenge_2013_min.gpx",
"volta_per_collserola_3_min.gpx",
"sta_coloma-masnou-pg_maritim_min.gpx",
"st_feliu_c-barnils-puigdolena_min.gpx",
"aiguafreda-pla_calma-collformic-la_castanya-montseny-el_molar_min.gpx",
"mercabarna-delta_llobregat_min.gpx",
"port_selva-carretera_roses_perafita_min.gpx",
"cabreres_2023_min.gpx",
"dolmens_serra_de_larca-pla_calma-aiguafreda_min.gpx",
"sant_feliu-soler_del_coll-centelles-popa-sant_feliu_min.gpx",
"bac_de_divi-paller_min.gpx",
"baga-coll_de_merolla-campdevanol_v3_min.gpx",
"TP_10_escalona-fiscal_min.gpx",
"baga-greixer-escriu-empedrats-baga_min.gpx",
"10VP-vilar_de_barrio-ourense-silleda_min.gpx",
"arres_de_sus-mina_victoria_min.gpx",
"3VP-villafranca_de_los_barros-merida-caceres_min.gpx",
"baga-coll_turbians-coll_bena-st_marti_puig_min.gpx",
"la_portals_2024_min.gpx",
"orbea-monegros-2024_min.gpx",
"centelles_stfeliu_min.gpx",
"la_floresta-vilanova_i_la_geltru-v2_min.gpx",
"alp-collada_toses-planoles-collet_barraques-ribes_freser_min.gpx",
"vanoise-pointe_des_fours_min.gpx",
"integral_carretera_aigues_3_min.gpx",
"volta_per_st_feliu_1_min.gpx",
"sant_feliu-sant_miquel_del_fai-sant_quirze_safaja_min.gpx",
"caldes-el_farell-coll_monner-castellar_min.gpx",
"vanoise-la_ramasse_min.gpx",
"trialerada-per-collserola_min.gpx",
"TP_09_bonansa-escalona_min.gpx",
"caldes_montbui-castell_montbui-st_feliu-st_quirze_min.gpx",
"cornella-martorell_min.gpx",
"baga-coll_de_pal-gavarros_min.gpx",
"st_vicenc_calders-la_pobla_claramunt_min.gpx",
"figaro-sant_marti_c-cingles_de_berti-sant_feliu_c-riells-la_garriga_min.gpx",
"montseny-turo_home_min.gpx",
"cercs-l_erola_min.gpx",
"TP_05_bagà-noves_de_segre_min.gpx",
"st_miquel_del_fai_uno_ulla_min.gpx",
"aiguafreda-sabadell_min.gpx",
"la-catllaras-2018_min.gpx",
"congost_mont-rebei_min.gpx",
"les_rovires_de_baix-ripoll_min.gpx",
"volta_per_collserola_2_min.gpx",
"palautordera-collformic-aiguafreda_min.gpx",
"st_feliu_codines-tenes-besos-bcn_min.gpx",
"baga-cerdanyola-st_jaume_frontanya-campdevanol_min.gpx",
"blanes-gavarres-girona_min.gpx",
"Vacarisses-Obac-St_Llorenc_Savall-Gallifa-St_Feliu_min.gpx",
"vanoise-llac_clar_min.gpx",
"gelida-sant_vicenc_dels_horts_min.gpx",
"la_floresta-vilanova_i_la_geltru_min.gpx",
"aiguafreda-fondrats-bellit-tagamanent_min.gpx",
"sant_privat_den_bas-puisacalm-sallent_min.gpx",
"sabadell-marquet_de_les_roques_min.gpx",
"berga-cal_rosal_st_maurici_de_la_quar-la_portella_min.gpx",
"KKH_min.gpx",
"sant_salvador_de_les_espases_min.gpx",
"juneda-mas_de_melons-les_garrigues_min.gpx",
"serra_galliners_part_2_min.gpx",
"cal_cerdanyola-monnell-murcurols-el_puig_min.gpx",
"urtx-alp-cortal_vidal-penyes_altes-dia_1_min.gpx",
"moia-estany-rodons-montbru_min.gpx",
"baga-via_nicolau-coll_turbians_min.gpx",
"vic-collformic-canovelles_min.gpx",
"MV3-cabra_de_mora-bezas_min.gpx~",
"caldes_de_montbui-barcelona_min.gpx",
"port_de_la_selva-cadaques-gr-92_min.gpx",
"malanyeu-grau_del_griell-foradada_min.gpx",
"cornella-delta_llobregat-viladecans_min.gpx",
"sant_feliu_codines_sabadell_min.gpx",
"les_rovires_de_baix_6_min.gpx",
"sta_coloma_gr-vallencana-badalona-vilanova-alella-montgat_min.gpx",
"baga-gavarros-rebost_min.gpx",
"baga-coll_de_la_pelosa_min.gpx",
"volta_per_collserola_1_min.gpx",
"TNR-4_min.gpx",
"blanes-mataro_min.gpx",
"la_floresta-papiol-st_bartomeu-olerdola-baixador_vallvidrera_min.gpx",
"centelles-collsuspina-canovelles_min.gpx",
"Centelles-Collsuspina-Popa-St_Feliu_de_Codines_min.gpx",
"baga-st_julia_cerdanyola-malanyeu-la_nou-vilada-st_quirze_besora_min.gpx",
"sant_marti_sesgueioles-prats_rei-maians-castellfollit-manresa_min.gpx",
"cueva_de_agreda-moncayo_min.gpx",
"TNR-2_min.gpx",
"sitges-barcelona_min.gpx",
"port_selva-vall_sta_creu_min.gpx",
"manresa-sant_feliu_min.gpx",
"9VP-puebla_de_sanabria-vilar_de_barrio_min.gpx",
"coll_sant_marcal-matagalls_min.gpx",
"marxa_dels_castells-btt_min.gpx",
"manresa_bages_sud_min.gpx",
"poblat-iberic-puig-castellar_min.gpx",
"TGEGA-1-wangen_im_allgau-ammersee_min.gpx",
"MV1-castello-villahermosa_del_rio_min.gpx",
"mollet-gallecs-caldes-3_maries-el_farell-st_feliu_min.gpx",
"vanoise-bonneval-lecot_min.gpx",
"manresa-rellinars-terrassa_min.gpx",
"baga-coll_descriga-coll_de_turbians_min.gpx",
"volta_per_collserola_10_min.gpx",
"pla_de_beret-bonabe-isil-port_de_la_bonaigua_min.gpx",
"pedro_de_tubau_min.gpx",
"sant_sadurni_danoia-orpinell-la_llacuna-mas_pontons-torrelles-monjos_min.gpx",
"baga-broca-collada-grossa-paller-de-dalt-paller-de-baix-baga_min.gpx",
"sant_feliu-collsuspina_min.gpx",
"montmelo-barcelona_min.gpx",
"riutort_pobla_de_lillet_min.gpx",
"baga-rebost-gavarros-coll_roig-collet_casa_nova-sant_vicenc_de_rus-la_pobla-guardiola_min.gpx",
"TP_13_echo-izaba_min.gpx",
"sant_feliu_de_c-vacarisses_min.gpx",
"st_feliu-la_garriga_min.gpx",
"vallcarca-tibidabo-pixandri-sol-i-aire_min.gpx",
"barcelona-sant_feliu_min.gpx",
"manresa-vic_min.gpx",
"sant_feliu_c-castelltercol-granera-sant_llorenc_savall_min.gpx",
"ripoll-les_rovires_de_baix_min.gpx",
"st_feliu_de_c-sta_coloma_de_gr_min.gpx",
"integral_carretera_aigues_2_min.gpx",
"malanyeu-la_nou_de_bergueda_min.gpx",
"cornella-castelldefels_min.gpx",
"volta_per_baga_3_min.gpx",
"TP_04_planoles-baga_min.gpx",
"montjuïc_360_min.gpx",
"premia-barcelona_min.gpx",
"el_plantiu-coll_cerqueda-erols-sant_vicenc_de_rus_min.gpx",
"prat_aguilo-comabona_min.gpx",
"gallecs-palau-solita-polinya-santiga-ripoll_min.gpx",
"baga-broca-pla_del_castell_min.gpx",
"TNR-9_min.gpx",
"mollet-gallecs-sta_perpetua_min.gpx",
"calaf-pinos-manresa_min.gpx",
"10-honeria_min.gpx",
"6VP-la_calzada_de_bejar-salamanca_min.gpx",
"Monegros-nord_min.gpx",
"cornella-castelldefels-ratpenat-begues-v2_min.gpx",
"8VP-granja_de_moreruela-puebla_de_sanabria_min.gpx",
"baga-coll_de_pal_v2_min.gpx",
"volta_per_collserola_12_min.gpx",
"castells_loira_min.gpx",
"les_rovires_de_baix_1_min.gpx",
"st_feliu_c-st_quirze_safaja-st_miquel_del_fai_min.gpx",
"baga-bena-bauma-collell-saldes-riu_de_saldes_min.gpx",
"NO-volta_per_sant_feliu_6_min.gpx",
"vilanova-experience_garraf_penedes_2023_min.gpx",
"baga-coll_turbians-roca_de_cans_min.gpx",
"sant_feliu-gorg_negre_min.gpx",
"volta_per_collserola_13_min.gpx",
"volta_per_sant_feliu_4_min.gpx",
"MV8-barracas-sagunt_min.gpx",
"integral_megalitica_vallromanes_min.gpx",
"entreno_baga_1_min.gpx",
"baga-via_del_nicolau-font_vinyavella-coll_turbians_min.gpx",
"st_feliu-riells-puigracios-figaro-cardedeu-granollers_min.gpx",
"sender_arqueologic_eyna_min.gpx",
"vacarisses-montserrat-cami_sant_jeroni-castellbell_min.gpx",
"xalet_coll_de_pal-gavarros-guardiola-baga-l_hospitalet_min.gpx",
"cornella-castelldefels-ratpenat-begues_min.gpx",
"port_selva-selva_mar-mas_romanyac-perafita-cadaques-GR92_min.gpx",
"collformic-matagalls_min.gpx",
"manresa-vilafranca_del_penedes_min.gpx",
"baga-cap_del_tossal_v0_min.gpx",
"st_feliu_cod-volta_a_la_popa_min.gpx",
"all-greixer-olopte_min.gpx",
"vanoise-refugi_daverole_min.gpx",
"montnegreopenmtb_50_min.gpx",
"port_selva-st_pere_de_rodes-llança-puig_tifeu-garbet_min.gpx",
"andorra-tarrega-dia_3_min.gpx",
"berga-pont_pedret-cal_rosal-sant_elies_min.gpx",
"st_feliu-can_deu-collet_termes_min.gpx",
"campdevanol-st_jaume_frontanya-cerdanyola-baga_min.gpx",
"st_quirze_besora-riera_merles_min.gpx",
"la_pobla_de_lillet-falgars_min.gpx",
"VCC1-manresa-vic-st_quirze_besora_min.gpx",
"sant_feliu-sant_llorenc-vinardell-castelltercol-coll_termes_min.gpx",
"andorra-tarrega-dia_2_min.gpx",
"barcelona-arrabassada-st_cugat-cerdanyola-barcelona_min.gpx",
"can_deu_del_veinat-collet_de_termes-coll_de_poses-cami_dels_horts_min.gpx",
"girona-gavarres-calonge-macanet_min.gpx",
"baga-cap_del_tossal_min.gpx",
"TNR-1_min.gpx",
"riugreixer-camping_min.gpx",
"baga-coll_merolla-campdevanol_min.gpx",
"volta_per_collserola_8-pujada_can_borni_min.gpx",
"sant_feliu_codines-barcelona_min.gpx",
"centelles-collsus-sta_col_sasserra-castelltercol-uixols_min.gpx",
"volta_per_collserola_7_min.gpx",
"port_selva-3_dolmens_taballera_min.gpx",
"TP_12_aurín-echo_min.gpx",
"corriolada_per_sant_just_desvern_min.gpx",
"11VP-silleda-santiago_de_compostela_min.gpx",
"la-portals-2013-4a-volta-a-la-montanya-de-montserrat-en-btt_min.gpx",
"granollers-roc_de_centelles_min.gpx",
"sant_celoni-santa_coloma_de_gr_min.gpx",
"pobla_claramunt-mollons-castellcastelloli_min.gpx",
"roncesvalles_min.gpx",
"penyes_altes-baga-dia_2_min.gpx",
"TNR-5_min.gpx",
"TNR-3_min.gpx",
"manresa-sant_sadurni_d_anoia_min.gpx",
"beinn-a-chrulaiste_min.gpx",
"TNR-0_min.gpx",
"grau_del_rei-aigues_mortes_min.gpx",
"Canovelles-Samalus-Roc_Centelles-Canoves-Marata_min.gpx",
"queralt-espinalbet-la_figuerassa_min.gpx",
"terrassa-barcelona_min.gpx",
"campdevanol-coll_merolla-baga_min.gpx",
"llimiana-serra-barcedana-gercles_min.gpx",
"bardenas_reales_min.gpx",
"marxa_del_montserrati_2024_min.gpx",
"serra_urbasa_min.gpx",
"MV4-bezas-griegos_min.gpx",
"caldes_monbui-castell_montbui-st_feliu-st_quirze_min.gpx",
"mollerussa-tarrega-cervera-sant_guim-sant_marti_sesgueioles_min.gpx",
"aiguafreda-vallcarquera-canoves-la_garriga_min.gpx",
"uelhs-deth-joeu-plan-dera-artiga-de-lin_min.gpx",
"baixador_vallvidrera_delta_llobregat_min.gpx",
"can_deu-termes-uixols-castelltercol-llogari-granera-gallifa_min.gpx",
"igualada-cervera-igualada_min.gpx",
"montnegreopenmtb_32_min.gpx",
"ripoll-macanet_massanes_via_verda_min.gpx",
"volta_per_sant_feliu_2_min.gpx",
"serra_galliners-v1_min.gpx",
"valldan-campllong-terrers_min.gpx",
"lleida-st_vicenc_calders_min.gpx",
"la_sala-sta_cecilia_riutort-coll_cerqueda-coll_portelletes_min.gpx",
"manresa-cami_ral-barcelona_min.gpx",
"entreno_collserola_oriental_v2_min.gpx",
"volta_per_baga_1_min.gpx",
"VCC2-st_quirze_besora-berga-solsona_min.gpx",
"gironella-avia-berga-pedret-obiols-gironella_min.gpx",
"manresa-berga-baga_min.gpx",
"collet-coll_pradell_min.gpx",
"palautordera-aiguafreda_min.gpx",
"pessonada-herba_savina_min.gpx",
"Sant_feliu_codines-Terrassa_min.gpx",
"paller-sant_marc_de_broca_min.gpx",
"1VP-sevilla-castilblanco_de_los_arroyos_min.gpx",
"carros_foc_min.gpx",
"baga-broca-collada_grossa-estret-riutort_min.gpx",
"sta_coloma-tenes-st_feliu_min.gpx",
"volta_per_sant_feliu_5_min.gpx",
"volta_per_collserola_6_min.gpx",
"andorra-tarrega-dia_1_min.gpx",
"baix_bergueda_min.gpx",
"garraf-begues-garraf_min.gpx",
"montmelo-cardedeu-la_garriga_min.gpx",
"volta_per_collserola_4-corriols-v2_min.gpx",
"volta_per_collserola_4-corriols_min.gpx",
"les_rovires_de_baix-pedro_de_tubau_min.gpx",
"manresa-la_sala-callus-castellnou-santpedor_min.gpx",
"TP_02_albanya-camprodon_min.gpx",
"l_hospitalet-coll_jou-penyes_altes-canal_serp-greixer_min.gpx",
"selenika_2024_min.gpx",
"vilafranca_del_p-sant_andreu_de_la_b_min.gpx",
"ruta_cister_gr_175_min.gpx",
"cambra_del_boc_min.gpx",
"volta_per_collserola_11_min.gpx",
"carretera_de_la_roca_min.gpx",
"cami_feliuans-mola_gallifa_min.gpx",
"sant_celoni-turo_de_lhome_v2_min.gpx",
"st_vicenc_castellet-obac-estenalles-st_llorenc_savall-st_feliu_codines_min.gpx",
"aiguafreda-monistrol_de_calders_min.gpx",
"TP_08_espui-bonansa_min.gpx",
"baga-sant_joan-matallops-vinyavella_min.gpx",
"volta_collserola_4_ermites_min.gpx",
"mirador_de_la_figuerassa_min.gpx",
"espierba-punta_el_cuezo_min.gpx",
"llinars-el_sui-pla_de_la_calma-el_bellit-aiguafreda_min.gpx",
"baga-collet_aina-jou-fumanya-vallcebre_min.gpx",
"vilafranca_del_penedes-martorell_min.gpx",
"port_selva-taballera-birba-gr92_min.gpx",
"port_selva-coll_bombo-pla_causa-puig_sardina-roses-mas_romanyac-GR9_min.gpx",
"TGEGA-3-tegernsee-innsbruck_min.gpx",
"sant_pere_de_rodes_min.gpx",
"volta_port_de_la_selva_min.gpx",
"NO-sta_coloma-el_masnou-pg_maritim_min.gpx",
"MV5-griegos-zafrilla_min.gpx",
"port_de_la_selva-sant_pere_de_r-sant_onofre-palau_saverdera_min.gpx",
"lleida-aiguabarreig_segre_cinca-la_granja_descarp_min.gpx",
"ribes-coll_de_jou-taga-ogassa-camprodon-abella-collada_verda-ribes_min.gpx",
"cavalls_del_vent_min.gpx",
"vanoise-lac_blanc_min.gpx"
];
return rutes;
}
export default llista_rutes;
